type Props = Readonly<{
  value: string;
  label?: string;
}>;

export const InputReadonly = ({ value, label }: Props) => {
  return (
    <div className="flex w-full flex-col gap-2">
      <span className="label">{label}</span>
      <span className="py-1 text-sm">{value}</span>
    </div>
  );
};
